import React, { useState, useEffect, useContext } from 'react';
import Heading from '../../GitHubComponents/Heading'
import Button from '../../GitHubComponents/Button'
import OrgStripBox from '../../GitHubComponents/OrgStripBox'
import { fetchUserSubscriberData } from "../../services"
import { MyContext } from '../..';
import { Link } from 'react-router-dom';

export default function Subscriber(props) {
    document.title = props.title
    const { backendUrl } = useContext(MyContext)
    const queryParameters = new URLSearchParams(window.location.search);
    const username = queryParameters.get("username") || props.userData.username
    const [organizationsData, setOrganizationsData] = useState([])

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await fetchUserSubscriberData(backendUrl, username);
                setOrganizationsData(data.data);
            } catch (error) {
                console.error('Error fetching Users data:', error);
            }
        }
        fetchData();
    }, [backendUrl, username]);
    return (
        <div className='organizations-body'>
            <div className="organization-head">
                <Heading heading="Organizations" style={{border: "none"}}/>
                <Link to={"../neworganization"}><Button text={"New organization"} type={"button"} style={{fontSize: "12px"}} /></Link>
            </div>
            {
                organizationsData && organizationsData?.map((organization, i)=>(
                    <OrgStripBox key={i} url={`../../organization?subcode=${organization.subscriber_code}`} text={organization.organization_name} lable={organization.roles} buttonText="Leave"/>
                ))
            }
        </div>
    )
}
